import React, { ReactEventHandler, useEffect, useState } from 'react'
import { AlertType, classBorderLabelDark, classBt, classInput, classInputDark, classLabel, classLabelDark, classbtAzul, classbtColunasVermelho } from '../../Utils/Types'
import { FeedbackMessage } from '../FeedbackMessage/feedback-message'
import { FaSave } from 'react-icons/fa'
import { SubGrupoService } from '../../Pages/SubGrupo/SubGrupoService'
import { GiArchiveRegister } from 'react-icons/gi'


type Props = {

    setIdSgrupo: (id: number) => void
    visible: boolean
    modalConfirmClick?: ReactEventHandler
    closeModal: () => void

}

export const ModalSubGrupo = React.memo(({ setIdSgrupo, visible, modalConfirmClick, closeModal }: Props) => {

    const [loading, setLoading] = useState(false)
    const [message, setMessage] = useState("")
    const [messageType, setMessageType] = useState<AlertType>("DANGER")
    const [visibleMSG, setVisibleMSG] = useState(false)

    const [idSubGrupo, setIdSubGrupo] = useState(0)
    const [descSubGrupo, setDescSubGrupo] = useState("")


    useEffect(() => {

        if (visible) {

            let modal = document.getElementById('modal_subGrupo')
            let modalContent = document.getElementById('modal_content_subGrupo')

            if (modal) {
                modal.style.visibility = 'visible'

                if (modalContent) {
                    modalContent.classList.remove('mt-[-400px]')
                    modalContent.classList.add('mt-24')
                }
            }

            const aguarde = setTimeout(() => {
                InputFocus()
                clearTimeout(aguarde)
            }, 200)

        } else {

            let modal = document.getElementById('modal_subGrupo')
            let modalContent = document.getElementById('modal_content_subGrupo')

            if (modal) {
                modal.style.visibility = 'hidden'

                if (modalContent) {
                    modalContent.classList.add('mt-[-400px]')
                    modalContent.classList.remove('mt-24')
                }
            }

            setDescSubGrupo("")
            setIdSubGrupo(0)
            setVisibleMSG(false)
            setLoading(false)

        }

    }, [visible])

    const hadleChangeDesc = (e: React.ChangeEvent<HTMLInputElement>) => {
        setDescSubGrupo(e.target.value)
    }

    const handleCloseMessage = () => {
        setVisibleMSG(false)
    }

    const handleSave = async (e: any) => {

        setVisibleMSG(false)

        try {

            let subGrupo: any = {
                id: idSubGrupo || 0,
                description: descSubGrupo
            }

            setLoading(true)
            const resp = await SubGrupoService.Save(subGrupo)
            //setLoading(false)

            InputFocus()

            if (resp.error) {

                setVisibleMSG(true)
                setMessageType("DANGER")
                setMessage(resp.msg || "")
                setLoading(false)

            } else {

                setVisibleMSG(true)
                setMessageType("SUCCESS")
                setMessage("Dados salvos com sucesso")

                setIdSubGrupo(resp.id || 0)
                setIdSgrupo(resp.id || -1)

                const aguarde = setTimeout(() => {
                    if (modalConfirmClick) {
                        modalConfirmClick(e)
                    }
                    clearTimeout(aguarde)
                }, 500)

            }

        } catch (error) {

            setVisibleMSG(true)
            setMessageType("DANGER")
            setMessage("Ocorreu um erro ao salvar o subgrupo")
            setLoading(false)

        }
    }

    const InputFocus = () => {
        const input = document.getElementById('subGrupo')
        if (input) {
            input.focus()
        }
    }

    const handleKeyPressEnter = async (event: any) => {

        if ((event.code === "Enter" || event.code === "NumpadEnter") && visible) {

            event.preventDefault() // Evita o comportamento padrão do 'Enter'

            InputFocus()

        }
    }

    const handleTabPress = (event: any) => {

        if (event.key === 'Tab' && visible) {

            event.preventDefault() // Evita o comportamento padrão do 'Tab'

        }
    }

    useEffect(() => {

        document.addEventListener('keydown', handleKeyPressEnter)
        document.addEventListener('keydown', handleTabPress)

        return () => {

            document.addEventListener('keydown', handleKeyPressEnter)
            document.addEventListener('keydown', handleTabPress)
        }
    }, [visible])

    return (

        <div id="modal_subGrupo" style={{ visibility: "hidden", backgroundColor: 'rgba(0,0,0, 0.6)' }} className={`flex justify-center fixed left-0 right-0 top-0 bottom-0 transition-all duration-300 z-40`}>

            <div id="modal_content_subGrupo" className={`relative flex flex-col w-[90%] sm:w-[70%] md:w-[50%] lg:w-[40%] xl:w-[30%] 2xl:w-[25%] h-[230px] bg-white dark:bg-slate-600 rounded-lg mt-[-400px] transition-all duration-300 justify-center items-center`}>

                <FeedbackMessage visible={visibleMSG} message={message} type={messageType} onCloseMessage={handleCloseMessage} />

                <div className={`absolute top-0 w-full h-[70px] flex items-center`}>

                    <div className={`ml-4 flex items-center justify-center h-10 w-10 rounded-full bg-slate-100 dark:bg-slate-500 border border-slate-300 dark:border-slate-700 shadow-sm shadow-slate-500 dark:shadow-slate-800`}>
                        <GiArchiveRegister className={`w-5 h-5 text-gray-800 dark:text-slate-100`} />
                    </div>

                    <span className={`ml-4 text-lg text-slate-700 dark:text-slate-200 flex items-center font-semibold`}>Cadastro - SubGrupo</span>

                </div>

                <div className={`absolute top-[70px] bottom-[60px] w-full h-full px-3 py-4`}>

                    <div className={`relative col-span-3`}>
                        <input id="subGrupo" className={`${classInput} ${classInputDark}`} type="text" inputMode='text' placeholder=" " autoComplete="off" value={descSubGrupo} onChange={hadleChangeDesc} />
                        <label htmlFor="subGrupo" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Descrição</label>
                    </div>

                </div>

                <div className={`absolute bottom-0 w-full h-[60px] flex items-center justify-end bg-slate-100 dark:bg-slate-600 border border-slate-200 dark:border-slate-500 border-x-0 border-b-0 py-4 px-3 rounded-b-lg space-x-3`}>

                    <button
                        tabIndex={-1}
                        disabled={loading}
                        onClick={closeModal}
                        className={`${loading ? 'opacity-40' : ''} ${classbtColunasVermelho} sm:max-w-[150px]`}>
                        CANCELAR
                    </button>

                    <button
                        tabIndex={-1}
                        disabled={loading}
                        onClick={handleSave}
                        className={`${loading ? 'opacity-40' : ''} ${classbtAzul} ${classBt} sm:max-w-[150px]`}>
                        {!loading && <FaSave size={"18px"} className='mr-2' />}
                        {loading &&
                            <div className="h-[20px] w-[20px] mr-1 animate-spin rounded-full border-4 border-solid border-current border-r-transparent align-[-0.125em] text-neutral-100 motion-reduce:animate-[spin_1.5s_linear_infinite]"
                                role="status">
                                <span className="!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]">Loading...</span>
                            </div>
                        }
                        {!loading ? `SALVAR` : "AGUARDE"}
                    </button>

                </div>

            </div>

        </div>

    )



})